import React, { useContext, useState, useEffect, useCallback } from "react";
import { BrowserRouter, Switch, NavLink, Route, Redirect, useRouteMatch } from "react-router-dom";
import { useTranslation } from "../../context";
import Layout from "../../Layout";
import api from "../../api";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import events from "../../context/events";
import TableList from "../../components/TableList";
import { JustifyContent } from "../../components/TableList/BaseComponents/Header";
import { getIconUrl, time } from "../../util";
import { changeEgovUrl } from "@/utils/tools";
import { Icons } from "../../Icon";
import ShareIcon from "../../components/List/ShareIcon";
import Popover from "./Popover";
import { pageSize } from "../../config/basics.config";
import { Button, message, Modal } from "antd";
import { ActionFnEnum, ContextMenuMode, FileType, MenusType } from "../../types";
import { PageRouteName } from "../../batchOperate";
import "../../common/index.less";
import "./index.less";
import UpdataService from "../../reloadUtils";
import { useListData } from "../../components/TableList/Use/useListData";

const columns = [
  { title: "标题", key: "title", dataIndex: "title", ellipsis: true },
  {
    title: "删除时间",
    key: "time",
    dataIndex: "time",
    width: "20%",
    style: {
      minWidth: "142px"
    },
    justifyContent: JustifyContent.Left
  },
  {
    title: "",
    key: "actions",
    dataIndex: "actions",
    actions: true,
    width: "10%",
    style: {
      minWidth: "30px"
    },
    justifyContent: JustifyContent.Center
  }
];
const key = MenusType.TRASHES;
const getList = (params: any) => {
  return new Promise((resolve, reject) => {
    api.pages
      .trashes(params)
      .then((res) => {
        if (res) {
          res.pages = (res.trashes || []).map((item: any) => {
            item.time = time.format(item.updated_at);
            item.title = item.title || "无标题";
            // item.isDisabled = true;
            return item;
          });
        }
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
function TrashesList(props: { setTotalLenth?: Function }) {
  const { setTotalLenth } = props;
  const {
    list,
    setList,
    total,
    setTotal,
    loading,
    isLoadMore,
    setLoadMore,
    onButtom,
    setPageIndex
  } = useListData({
    requestPagesFunc: getList,
    isFilter: false,
    isCategory: false,
    key
  });

  useEffect(() => {
    setTotalLenth?.(total);
  }, [total, setTotalLenth]);

  return (
    <div className="joyspace-trashes joyspace-list-table joyspace-child-list">
      <TableList
        isLoadMore={isLoadMore}
        columns={columns}
        list={list}
        loading={loading}
        isRoot={false}
        from={PageRouteName.TRASHES}
        pagination={true}
        showAI={false}
        renderActions={(item: any, contextMenuMode = ContextMenuMode.Click) => {
          if (item.isDisabled) {
            return (
              <span className="joyspace-trigger-icon" style={{ color: "#cccccc" }}>
                {Icons.trigger}
              </span>
            );
          }
          return (
            <Popover
              data={item}
              fileType={item.icon_url ? FileType.Page : FileType.Folder}
              contextMenuMode={contextMenuMode}
              callbackProps={{
                data: item,
                setData: (data: any) => {
                  events.emit("list.partial.refresh", {
                    changeData: data,
                    key
                  });
                }
              }}
            />
          );
        }}
        preOptions={(item, data, isExist) => {
          return (
            item.dataIndex === "title" &&
            (data.icon_url ? (
              <img
                src={
                  !isExist ? changeEgovUrl(data.icon_url) : getIconUrl(data.type || data.page_type)
                }
                data-icon
              />
            ) : (
              <ShareIcon isShared={false} />
            ))
          );
        }}
        onButtom={onButtom}
        // handleItem={openPage}
      />
    </div>
  );
}

export default function () {
  const lang = useTranslation();
  const { onLine } = useContext(GlobalContext);
  const [total, setTotal] = useState<number>(0);
  const emptyTrash = useCallback(() => {
    if (total === 0) {
      message.warning(lang("回收站暂无内容"));
      return;
    }
    Modal.confirm({
      title: "确定清空回收站吗？清空后将不能恢复。",
      cancelText: lang("common.cancel"),
      okText: lang("common.confirm"),
      onOk: () => {
        api.trashes
          .empty()
          .then((data) => {
            if (data) {
              events.emit("list.reload");
              message.success(lang("common.empty-success"));
            } else {
              message.error(lang("common.fail"));
            }
          })
          .catch((e) => {
            e && message.error(e);
          });
      }
    });
  }, [lang, total]);
  return (
    <div className="joyspace-trashes-wrap">
      <Layout>
        <div className="joyspace-header">
          <Layout.Breadcrumbs text={lang("trashes.title")} />
          <Button
            type="primary"
            shape="round"
            disabled={!onLine}
            className="trash-empty"
            onClick={emptyTrash}
          >
            清空
          </Button>
        </div>
        <TrashesList setTotalLenth={setTotal} />
      </Layout>
    </div>
  );
}
